import React from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useComplianceCentre } from '../context/ComplianceCentreContext';
import { eventRow } from '../complianceCentreUi';

export default function UpcomingEvents() {
  const { data, setPanel, emptyMessage } = useComplianceCentre();
  const events = (data?.events || []).slice(0, 5).map(eventRow);

  return (
    <div className="w-full max-w-md bg-white rounded-2xl p-5 border border-gray-100 shadow-sm font-sans select-none flex flex-col justify-between">
      
      {/* 1. Header Card Row */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-gray-900 font-extrabold text-base tracking-tight text-left">
          Upcoming Events & Inspections
        </h3>
        <button type="button" onClick={() => setPanel("calendar")} className="text-xs font-bold text-blue-600 hover:text-blue-700 transition flex items-center space-x-1">
          <span>View calendar</span>
          <FiChevronRight className="w-3.5 h-3.5 mt-0.5" />
        </button>
      </div>

      {/* 2. Structured Content Rows List */}
      <div className="divide-y divide-gray-50 flex-1">
        {!events.length && <p className="py-5 text-xs text-slate-400">{emptyMessage('No equipment events scheduled in the next 30 days. Inspections are not tracked.')}</p>}
        {events.map((event) => {
          const EventIcon = event.icon;
          return (
            <Link to={event.path} key={event.id} className="py-3 flex items-center justify-between space-x-4 group hover:bg-slate-50/30 px-1 rounded-xl transition duration-150">
              
              {/* Left Grouping: Icon Badge & Content Texts */}
              <div className="flex items-center space-x-3.5 min-w-0">
                {/* Rounded background colored icon container */}
                <div className={`w-9 h-9 ${event.iconStyles} rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm`}>
                  <EventIcon className="w-4 h-4" />
                </div>
                
                {/* Label text strings stack */}
                <div className="text-left min-w-0 space-y-0.5">
                  <span className="block text-xs md:text-sm font-bold text-slate-900 truncate">
                    {event.title}
                  </span>
                  <span className="block text-[11px] font-medium text-slate-400">
                    {event.date}
                  </span>
                </div>
              </div>

              {/* Right Side Time Counter Badge Tag */}
              <div className="flex-shrink-0">
                <span className={`inline-block text-[10px] md:text-xs font-black px-2.5 py-1 rounded-lg ${event.tagStyles}`}>
                  {event.tagText}
                </span>
              </div>

            </Link>
          );
        })}
      </div>

      {/* 3. Bottom Footer Submission Button Area */}
      <div className="pt-3 border-t border-gray-100 mt-2">
        <button type="button" onClick={() => setPanel("events")} className="w-full text-xs font-bold text-blue-600 hover:text-blue-700 transition flex items-center justify-center space-x-1 py-1.5 hover:bg-blue-50/30 rounded-xl">
          <span>View all events</span>
          <FiChevronRight className="w-3.5 h-3.5 mt-0.5" />
        </button>
      </div>

    </div>
  );
}
